export const config = {
  rowSelection: false,
  columns: [
    {
      title: "ID",
      dataIndex: "id",
      width: 100
    },
    {
      title: "产品类型",
      dataIndex: "prodTypeName",
      width: 50
    },
    {
      title: "产品SKU_ID",
      dataIndex: "refProductSkuId",
      width: 100,
      editable: true
    },
    {
      title: "产品名称（SKU）",
      dataIndex: "skuName",
      width: 120,
      editable: true
    },
    {
      title: "操作",
      width: 50,
      fixed: "right",
      render: "editCell"
    }
  ],
  search: [],
  footer: [
    {
      label: "添加",
      type: "primary",
      events: ["onClick:onAdd"]
    }
  ]
}
